import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ShortmessagesApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'shortMessages'
    }

   
    /**
     * 批量保存推送消息
     * @param params 
     * @returns 
     */
    public savesList(params){
        return this.send(params,"savesList",Methods.POST)
    }

    /**
     * 批量保存推送消息
     * @param params
     * @returns
     */
    public saveQYWXList(params){
        return this.send(params,"saveQYWXList",Methods.POST)
    }

    /**
     * 批量保存推送消息
     * @param params
     * @returns
     */
    public saveMobileList(params){
        return this.send(params,"saveMobileList",Methods.POST)
    }

   
}